<template>
  <div class="card row cardBemVindo">
    <div class="col-12">
      <h4>{{ $t('TOP 10 Problemas mais atendidos') }}</h4>
      <p>{{ $t('Nos últimos 30 dias') }}</p>
      <div class="chart-container">
        <canvas id="barChart"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels); // Se necessário, remova o plugin antes de registrar
Chart.plugins.register(ChartDataLabels); // Registra o plugin manualmente

export default {
  data() {
    return {
      problemasRepetidos: [], // Armazena os dados de problemas repetidos
      barColors: ['#f39c12', '#2ecc71', '#3498db', '#f03035', '#348c6f'], // Cores pré-definidas para as barras
    };
  },
  mounted() {
    // Disparar a action do Vuex para buscar os dados
    this.$store.dispatch('dashboard/getProblemasRepetidos').then(response => {
      this.problemasRepetidos = response.data.problemas_repetidos;

      // Criar labels únicas para o gráfico (datas)
      const labels = [...new Set(this.problemasRepetidos.map(item => item.data))];

      // Estruturar os dados do gráfico por problema
      const datasets = this.problemasRepetidos.reduce((acc, problema, index) => {
        const colorIndex = index % this.barColors.length; // Garantir que as cores sejam reaproveitadas quando necessário

        const dataset = {
          label: problema.nome_problema.trim(),
          data: new Array(labels.length).fill(0), // Inicializa com zeros
          backgroundColor: this.barColors[colorIndex], // Aplica a cor pré-definida
          borderColor: this.barColors[colorIndex], // Adiciona a mesma cor para a borda, sem transparência
          borderWidth: 1,
          barPercentage: 0.8, // Define a espessura das barras
        };

        // Atualiza a contagem de repetições na posição correta
        const labelIndex = labels.indexOf(problema.data);
        if (labelIndex !== -1) {
          dataset.data[labelIndex] += problema.total_repeticoes;
        }

        acc.push(dataset);
        return acc;
      }, []);

      // Dados do gráfico
      const data = {
        labels: ' ', // Labels com as datas
        datasets: datasets, // Conjunto de dados por problema
      };

      // Inicializar o gráfico de barras
      const ctx = document.getElementById('barChart').getContext('2d');
      this.renderChart(ctx, data);
    });
  },

  methods: {
    renderChart(ctx, data) {
      new Chart(ctx, {
        type: 'bar', // Tipo do gráfico
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false, // Para ajustar a altura
          scales: {
            y: {
              beginAtZero: true, // O eixo Y começa do zero
            },
          },
          plugins: {
            legend: {
              display: false, // Posição da legenda
            },
            // title: {
            //   display: true,
            //   text: 'Problemas mais atendidos no mês',
            // },
            datalabels: {
              anchor: 'center', // Mantém o valor no meio da barra
              align: 'center', // Alinha o número ao centro
              color: '#FFFFFF', // Define a cor do texto como branco
              font: {
                size: 18,
                weight: 'bold',
                family: 'Arial', // Escolha a fonte desejada
              },
              textStrokeColor: '#000', // Contorno preto (opcional)
              textStrokeWidth: 2, // Espessura do contorno para destaque
              formatter: function (value) {
                return value; // Exibe o valor corretamente
              },
            },
          },
          animation: {
            duration: 1,
            onComplete: function({ chart }) {
              const ctx = chart.ctx;
              chart.data.datasets.forEach((dataset, i) => {
                const meta = chart.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  ctx.fillText(data, bar.x, bar.y - 5);
                });
              });
            },
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.cardBemVindo {
  flex-direction: row;
  align-items: flex-end;
  margin-right: 10px;
}

.chart-container {
  height: 400px; /* Altura fixa do contêiner */
  position: relative; /* Para garantir que o gráfico se ajuste ao contêiner */
}

canvas {
  width: 100%; /* O gráfico ocupa toda a largura */
  height: 100%; /* O gráfico ocupa toda a altura do contêiner */
}

.details {
  margin-top: 20px;
  /* Espaçamento entre o gráfico e os detalhes */
}

table {
  width: 100%;
  /* Ocupar toda a largura disponível */
  border-collapse: collapse;
  /* Colapsa as bordas da tabela */
}

th,
td {
  border: 1px solid #ddd;
  /* Borda padrão para células */
  padding: 8px;
  /* Espaçamento interno nas células */
  text-align: left;
  /* Alinhamento à esquerda do texto */
}

th {
  background-color: #f2f2f2;
  /* Cor de fundo para cabeçalhos */
}

canvas {
  color: white !important;
}
</style>
